module.exports = __webpack_public_path__ + "static/refresh-logo-c65f9f18ddbf6ee9ea0959464d409756.png";